import { useChat } from "~/hooks/chat";
import { Container } from "./styles";

const OfflineChat: React.FC = () => {
  const { isExternal, company, submittedTeam, company_domain } = useChat();
  console.log(`A URL é ${company_domain}`);

  const companyConfigr = "5278e21e-e651-4883-8370-c61162f58d61";

  return (
    <Container>
      <span>Oi, no momento o nosso chat de atendimento está indisponível!</span>
      <img src="https://chat.cloudez.io/offChat.svg" alt="Chat Offline" />
      <span className="schedules">
        Você pode falar com a gente{" "}
        {submittedTeam === "3" || submittedTeam === null
          ? "de segunda à sexta-feira"
          : "de segunda à sexta-feira"}
        , das{" "}
        <b>
          {submittedTeam === "3" || submittedTeam === null ? "09h00" : "09h00"}
        </b>{" "}
        às{" "}
        <b>
          {submittedTeam === "3" || submittedTeam === null ? "18h00" : "12h00"}
        </b>
        {submittedTeam === "3" || submittedTeam === null ? (
          "!"
        ) : (
          <>
            {" "}
            e das <b>14h00</b> às <b>17h00</b>!
          </>
        )}
      </span>
      {isExternal ? (
        <span>
          Caso preferir, pode entrar em contato com a gente enviando um e-mail
          para{" "}
          <b>
            {company === companyConfigr
              ? "comercial@configr.com"
              : "selecao@cloudez.io "}
          </b>
        </span>
      ) : (
        <span>
          Caso preferir, pode entrar em contato com a gente utilizando abertura
          de um{" "}
          <a
            className="openTicket"
            href={`${window.location.origin}/tickets/create`}
          >
            ticket
          </a>
          .
        </span>
      )}
    </Container>
  );
};

export default OfflineChat;
